import { render, staticRenderFns } from "./NotAuthOrPhone.vue?vue&type=template&id=7d5f0af8&scoped=true"
import script from "./NotAuthOrPhone.vue?vue&type=script&lang=js"
export * from "./NotAuthOrPhone.vue?vue&type=script&lang=js"
import style0 from "./NotAuthOrPhone.vue?vue&type=style&index=0&id=7d5f0af8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d5f0af8",
  null
  
)

export default component.exports